import { API_PATH_INTERNAL } from '@/lib/constants'
import apiService from '@/lib/services/apiService'
import { NotificationsCollection } from '@/types/responses/notifications'

export default new (class SubscriptionService {
  private endpoint = `${API_PATH_INTERNAL}/notifications`

  async getNotifications(): Promise<NotificationsCollection> {
    const response = await apiService.get(this.endpoint)

    return response.data
  }
})()
